import { listCast } from '@platform/client';
import { castListSchema } from '@platform/schema/cast';

/** Portraits, readiness, what each character may do, and every prop — CAST-07, CAST-11. */
export const castQuery = {
  queryKey: ['cast'],
  queryFn: async () =>
    castListSchema.parse((await listCast({ throwOnError: true })).data),
  staleTime: Infinity,
};

/** "Betty, Buyer · Kofi, Seller": the lesson's cast as a reviewer reads it — CAST-05. */
export function castLine(
  cast: readonly { character: string; role: string }[],
): string {
  return cast
    .map(
      ({ character, role }) =>
        `${character.charAt(0).toUpperCase()}${character.slice(1)}, ${role}`,
    )
    .join(' · ');
}
